import { Components } from '../../../styles';
import * as tokens from '@utmost.co/utmost-design-tokens';

export const dateCalendar = {
  // @ts-ignore: MuiDateCalendar is a valid component but is part of diff package
  MuiDateCalendar: {
    styleOverrides: {
      root: {
        '.MuiButtonBase-root': {
          '&.Mui-selected': {
            color: tokens.colorOnPrimary,
            backgroundColor: `${tokens.colorPrimary} !important`,
            '&:hover': {
              background: tokens.paletteBlue50
            }
          }
        },
        '.MuiPickersDay-root.Mui-disabled:not(.Mui-selected)': {
          color: `${tokens.stateOnSurfaceDisabledContentStateLayerColor}`
        }
      }
    }
  }
} satisfies Components;
